export default {
  title: {
    id: 'front_office_product_core_telco_picker_title',
    defaultMessage:
      'Unlock an exclusive offer on a mobile plan to claim after checkout',
  },
  learnMore: {
    id: 'front_office_product_core_telco_picker_learn_more',
    defaultMessage: 'Learn more about the plans and how the offer works',
  },
  noPlanLabel: {
    id: 'product_page_telco_picker_no_plan_label',
    defaultMessage: 'No mobile plan',
  },
}
